import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { __ } from 'i18n-for-browser';
import BudgetSlider from '../elements/StepThree/BudgetSlider';
import BudgetCollaboration from '../elements/StepThree/BudgetCollaboration';
import FeedbackImage from '../elements/feedback/FeedbackImage';
import FeedbackEffect from '../elements/feedback/FeedbackEffect';
import actions from '../../actions';
import PopupTitle from "../elements/PopupTitle";
import Warning from "../../assets/img/icons/warning.svg";
import GoBackButton from "../elements/GoBackButton";
import PopUp from "../elements/PopUp";
import edgeArrow from "../../assets/img/arrowTax.png";

const { updateMyState, submitMyState } = actions.gameStateInput;

class TaxItem extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    title: PropTypes.string,
    notification: PropTypes.shape({}),
    icon: PropTypes.any,
    globas: PropTypes.any,
    points: PropTypes.any,
    feedbackData: PropTypes.shape({}),
    dataList: PropTypes.array,
    minValue: PropTypes.number,
    maxValue: PropTypes.number,
    sliderValue: PropTypes.number,
    collaborationValue: PropTypes.array,
    sliderKey: PropTypes.string,
    collaborationKey: PropTypes.string,
    notificationReference: PropTypes.string,
    reverseGlobasPoints: PropTypes.bool,
    ignorePopup: PropTypes.bool,
  };
  static defaultProps = {
    onChange: () => {},
    reverseGlobasPoints: true,
    title: 'title',
    icon: '',
    globas: 0,
    points: 0,
    dataList: [],
    minValue: 0,
    maxValue: 999,
    sliderKey: 'slider',
    collaborationKey: 'collaboration',
    feedbackData: {},
    notificationReference: '',
    notification: {},
    ignorePopup: false,
  };
  constructor (props) {
    super(props);
    this.state = {
      capNotification: props.sliderValue > props.cap,
      showSavePopup: false,
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange = (key, value) => {
    const { cap } = this.props;
    let capNotification;
    if (cap !== undefined) {
      if (value <= cap && value > 0) {
        capNotification = false;
      }
      if (value > cap) {
        capNotification = true;
      }
    }
    this.setState({
      capNotification: capNotification,
      sliderValue: value
    });

    this.props.dispatch(updateMyState({ [key]: value }));
  };

  renderDetails = data => {
    const { props } = this;
    let dataList = data;
    let colIndex = dataList.findIndex(item => item.title === 'Samenwerking met andere landen' || item.title === __('sim_samenwerkingmetanderelanden'));

    // Sort all groups to correct order
    if (colIndex !== -1 && dataList[colIndex].value.length) {
      let arr = dataList[colIndex].value;
      if (arr[0].props.src > arr[(arr.length - 1)].props.src) {
        dataList[colIndex].value = dataList[colIndex].value.sort(function(a, b){
          var nameA=a.props.src.toLowerCase(), nameB=b.props.src.toLowerCase();
          if (nameA < nameB)
            return -1;
          if (nameA > nameB)
            return 1;
          return 0;
        });
      }
    }

    return (
      dataList.map((item, topDataIndex) => {
          if(item.hideWhenZero) {
            const val = parseInt(item.value.split(' ')[0], 10);
            if(isNaN(val) || val === 0) return '';
          }
          if (Array.isArray(item.value) && !item.value.length) {
            item.value = '-';
          }
          return (<span key={topDataIndex}>
            {props.feedbackData.topData.length-1 === topDataIndex ? <div className={'border-line'}/> : null}
            <div className={'topdata-container'}>
              <p>{item.title}</p>
              <span>{item.value}</span>
            </div>
          </span>)
        }
      )
    )
  };

  closeSavePopup = (res) => {
    if(res) {
      const {props} = this;
      const buttonConditions = props.gameStateInput.myState.arbeidsBelasting >= 1 && props.gameStateInput.myState.arbeidsBelasting <= 79;
      if (buttonConditions && props.user.role === 'groupleader' && !props.gameStateInput.preventInputChanges) {
        props.dispatch(submitMyState('SIMULATION_TAX'));
      }
    }
    this.setState({
      showSavePopup: false,
    })
  }

  componentWillReceiveProps(props) {
    if (props.sliderValue > props.cap) {
      this.setState({capNotification: true});
    }
    if (this.props.feedbackData.show !== props.feedbackData.show) {
      this.setState({showDropDown: false});
    }
  }

  render() {
    const {props} = this;
    const buttonConditions = props.gameStateInput.myState.arbeidsBelasting >= 1 && props.gameStateInput.myState.arbeidsBelasting <= 79;
    return (
      <span className={'main-tax-container' + (this.props.showDropdown || props.feedbackData.show ? ' show' : '')}>
        {this.props.showDropdown && !props.feedbackData.show ?
          <span className={'small-tax'}>
            <div className="title-block">
              <div className={'title-center'}>
                <img alt="icon" src={this.props.icon}/>

                <PopupTitle customClass={'popup-heading'} popupId={props.popupId} tag={'h4'}/>
              </div>
              <GoBackButton history={this.props.history}/>
            </div>

            {/*<FeedbackImage image={props.feedbackData.img} description={props.feedbackData.imgDescription}/>*/}

            <div className={'content-container' + (this.props.showDropdown && !props.feedbackData.show ? ' show' : '')}>
              <div className="content-container-background"/>

              {props.dataList.map((item, index) =>
                <div key={index} className={'taxes-data'}>
                  <p>{item.title}:</p>
                  <li>
                    <span title={item.globas}>{item.globas}</span>
                    <p title={__('sim_miljard')}>{__('sim_miljard')}</p>
                  </li>
                </div>
              )}

              { props.taxDescription ?
                <p className={'description'}>{props.taxDescription}</p>
                : null }

              <div className={'border-line'}/>

              {props.sliderTitles !== undefined ?
                <div className={'slider-titles'}>
                  <p>{props.sliderTitles[0]}</p>
                  <p>{props.sliderTitles[1]}</p>
                </div>
                : null
              }

              {props.type === 'taxSlider' ?
                <div>
                  <p>{__('sim_gekozenbelastingpercentage')} ({props.minValue}-{props.cap}%)</p>
                </div>
                : null
              }

              <BudgetSlider
                role={this.props.user.role}
                customOnChange={this.onChange}
                onAfterChange={this.onAfterChange}
                onChangeKey={props.sliderKey}
                twoValueSlider={props.twoValueSlider}
                value={props.sliderValue}
                min={props.minValue}
                unit={props.unit}
                suffix={props.suffix}
                max={props.maxValue}/>

              <div className={'warning-element content-container taxes-slider-warning ' + (this.state.capNotification ? 'show' : '')}>
                <div className='content-container-background'/>
                <span>
                  <img src={Warning} alt="warning"/>
                  <p dangerouslySetInnerHTML={{ __html: props.capNotification }}/>
                </span>
              </div>
              <div className={'border-line'}/>

              {props.project.difficulty === 'BASIC' ? (
                <div className={'savebutton-container'}>
                  { !(props.gameStateInput.myState.SIMULATION_TAX === 'PROCESSED' && props.gameStateInput.myState.SIMULATION_TAX_2 === 'PROCESSED') && props.user.role === 'groupleader' ?
                    <button
                      onClick={(ev) => {
                        ev.preventDefault();
                        this.setState({
                          showSavePopup: true
                        })
                      }}
                      className={`button${buttonConditions && !props.gameStateInput.preventInputChanges ? '' : ' disabled'}`}
                    >
                      <span>{__('sim_opslaan')}</span>
                    </button>
                    : null
                  }
                  { this.state.showSavePopup ? (
                    <PopUp id={'dlgmstap3opslaan_1'} closePopUpClick={(res) => {this.closeSavePopup(res)}}/>
                  ) : null }
                </div>
              ) : null}


            { this.props.project.difficulty === 'PRO' ?
              <BudgetCollaboration
                value={props.collaborationValue}
                customOnChange={this.onChange}
                onChangeKey={props.collaborationKey}
                title={__('sim_selecteer_samenwerk_landen')+':'}/>
              : null }
            </div>
          </span> : ''
        }

        { this.props.showDropdown && props.feedbackData.show ?
          <div className={'feedback-container-taxes'}>
            <div className="title-block">
              <img alt="icon" src={this.props.icon}/>

              {this.props.ignorePopup ?
                <h4>{this.props.title}</h4>
                :
                <PopupTitle customClass={'popup-heading'} popupId={props.popupId} tag={'h4'}/>
              }

              {this.props.project.difficulty === 'BASIC' ?
                <h4 className="percentage">{__('sim_tarief')}: {props.sliderValue}%</h4> : ''
              }

              <div className='point-holder reverse'>
                <li>
                  <span title={props.points}>{props.points}</span>
                  <p title={__('sim_punten')}>{__('sim_punten')}</p>
                </li>
                <li>
                  <span title={props.globas}>{props.globas}</span>
                  <p title={__('sim_miljard')}>{__('sim_miljard')}</p>
                </li>
              </div>

              <GoBackButton history={this.props.history}/>
            </div>
            <div className={'taxes-content-row'}>
              <div className={'taxes-content-box'}>
                {props.feedbackData.topData.length ?
                  <div className={'content-container show taxes'}>
                    <div className={'content-container-background'}/>
                    {this.renderDetails(props.feedbackData.topData)}
                  </div>
                : ''}

                <FeedbackImage descriptionAbsolute={true} image={props.feedbackData.img} description={props.feedbackData.imgDescription}/>
              </div>

              <div className={'feedbackText taxes-content-box'}>
                <div className={'content-container show taxes'}>
                  <div className={'content-container-background'}/>
                  <span dangerouslySetInnerHTML={{ __html: props.feedbackData.description }}/>
                </div>
              </div>
            </div>


            {
              props.feedbackData.effects.length ?
                <div className={'effects-container feedbackdata-effects taxes'}>
                  <div className={'effects-container-half'}>
                    <div className={'effects-header-wrap'}>
                      <div className={'effects-header'}>
                        <div className={'effects-header-inner'}>
                          {__('sim_belastingkeuze_heeft_effect_op')}:
                        </div>
                      </div>
                      <div className={'edge-element'}><img src={edgeArrow} alt=""/></div>
                    </div>

                    <div className={'effects-message'}>
                      {__('sim_zie_deze_effecten_volgende_spelronden')}
                    </div>
                  </div>

                  <div className={'effects-container-half'}>
                    {props.feedbackData.effects.map((effect, i) => {
                      return (
                        <FeedbackEffect
                          key={i}
                          minimal={true}
                          ministry={effect.title}
                          ministryIcon={effect.icon}
                          description={'Onderschrift'}
                          unit={effect.contentUnit}
                          points={effect.contentTitle}>
                        </FeedbackEffect>
                      );
                    })}
                  </div>
                </div>

                : null
            }
          </div>
          : null }
        </span>
    );
  }
}

export default connect(state => state)(TaxItem);



// WEBPACK FOOTER //
// ./src/components/desktop/TaxItemMain.js